module.exports = __webpack_public_path__ + "img/BRCA2_B.0caaa0f6.png";